import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import FooterEn from "../footer-en";
import HeaderEn from "../header-en";

function SignUpEn(props) {
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [birthDay, setBirthDay] = useState(0);
  const [birthMonth, setBirthMonth] = useState(0);
  const [birthYear, setBirthYear] = useState(0);
  const [userSex, setUserSex] = useState("boy");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userPasswordCheck, setUserPasswordCheck] = useState("");
  const [signupError, setSignupError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [sendMessage, setSendMessage] = useState("Hello,I'mInSignupPageEn");

  useEffect(() => {
    handleRedirect();
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: sendMessage,
    });
    return true;
  };

  const submitHandler = async () => {
    var birthDate =
      birthYear.toString() +
      "/" +
      birthMonth.toString() +
      "/" +
      birthDay.toString() +
      " 00:00:00";
    if (
      userFirstName === "" ||
      userLastName === "" ||
      userEmail === "" ||
      userPassword === "" ||
      birthDay == 0 ||
      birthMonth == 0 ||
      birthYear == 0
    ) {
      setSignupError(true);
      setMessageError("Please fill in all fields");
      return;
    } else {
      setSignupError(false);
      // birthDate = moment(birthYear.toString()+'/'+birthMonth.toString()+'/'+birthDay.toString()+' 00:00:00', 'jYYYY/jM/jD HH:mm:ss').format('YYYY-M-D HH:mm:ss')
    }
    if (userPassword !== userPasswordCheck) {
      setSignupError(true);
      setMessageError("Passwords do not match");
      return;
    }
    const response = await axios.post(
      "https://request.kidiar.com/register/request",
      {
        firstname: userFirstName,
        lastname: userLastName,
        sex: userSex,
        password: userPassword,
        birthdate: birthDate,
        email: userEmail,
      }
    );
    console.log(response.data);

    if (response.data.auth == true) {
      localStorage.setItem("token", response.data.token);
      window.location.href = "/en/account/verify";
    } else {
      setSignupError(true);
      if (response.data.message === "این ایمیل قبلا انتخاب شده!") {
        setMessageError("This email has already an account!");
      } else {
        setMessageError(response.data.message);
      }
    }
  };

  return (
    <div className="container-v1">
      <HeaderEn />
      <div className="signup">
        <div className="signup-container justify-content-center">
          <div className="form-wrapper d-ltr" style={{ maxWidth: "500px" }}>
            <div className="d-flex">
              <h1>{"First create an account"}</h1>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-50">
                <p>{"Child first name"}</p>
                <input
                  className="form-input mie-2"
                  onChange={(e) => setUserFirstName(e.target.value)}
                ></input>
              </div>
              <div className="d-flex flex-column w-50">
                <p>{"Child last name"}</p>
                <input
                  className="form-input mis-2"
                  onChange={(e) => setUserLastName(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column">
                <p>{"Child birth date"}</p>
                <div className="d-flex">
                  <select
                    className="users-input"
                    style={{ width: "33.33%" }}
                    value={birthDay}
                    onChange={(e) => setBirthDay(e.target.value)}
                  >
                    <option value={0}>day</option>
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={6}>6</option>
                    <option value={7}>7</option>
                    <option value={8}>8</option>
                    <option value={9}>9</option>
                    <option value={10}>10</option>
                    <option value={11}>11</option>
                    <option value={12}>12</option>
                    <option value={13}>13</option>
                    <option value={14}>14</option>
                    <option value={15}>15</option>
                    <option value={16}>16</option>
                    <option value={17}>17</option>
                    <option value={18}>18</option>
                    <option value={19}>19</option>
                    <option value={20}>20</option>
                    <option value={21}>21</option>
                    <option value={22}>22</option>
                    <option value={23}>23</option>
                    <option value={24}>24</option>
                    <option value={25}>25</option>
                    <option value={26}>26</option>
                    <option value={27}>27</option>
                    <option value={28}>28</option>
                    <option value={29}>29</option>
                    {birthMonth < 12 && <option value={30}>30</option>}
                    {birthMonth < 7 && <option value={31}>31</option>}
                  </select>
                  <select
                    className="users-input"
                    style={{ width: "33.33%" }}
                    value={birthMonth}
                    onChange={(e) => {
                      if (e.target.value < 7) {
                      } else if (birthDay == 31 && e.target.value < 12) {
                        setBirthDay(30);
                      } else if (birthDay == 31 && e.target.value == 12) {
                        setBirthDay(29);
                      } else if (birthDay == 30 && e.target.value == 12) {
                        setBirthDay(29);
                      }
                      setBirthMonth(e.target.value);
                    }}
                  >
                    <option value={0}>Month</option>
                    <option value={1}>January</option>
                    <option value={2}>February</option>
                    <option value={3}>March</option>
                    <option value={4}>April</option>
                    <option value={5}>May</option>
                    <option value={6}>June</option>
                    <option value={7}>July</option>
                    <option value={8}>August</option>
                    <option value={9}>September</option>
                    <option value={10}>October</option>
                    <option value={11}>November</option>
                    <option value={12}>December</option>
                  </select>
                  <select
                    className="users-input"
                    style={{ width: "33.33%" }}
                    value={birthYear}
                    onChange={(e) => setBirthYear(e.target.value)}
                  >
                    <option value={0}>Year</option>
                    <option value={2023}>2023</option>
                    <option value={2022}>2022</option>
                    <option value={2021}>2021</option>
                    <option value={2020}>2020</option>
                    <option value={2019}>2019</option>
                    <option value={2018}>2018</option>
                    <option value={2017}>2017</option>
                    <option value={2016}>2016</option>
                    <option value={2015}>2015</option>
                    <option value={2014}>2014</option>
                    <option value={2013}>2013</option>
                    <option value={2012}>2012</option>
                    <option value={2011}>2011</option>
                    <option value={2010}>2010</option>
                  </select>
                </div>
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row">
                  <input
                    type="radio"
                    checked={userSex === "boy"}
                    onChange={() => setUserSex("boy")}
                  ></input>
                  <p>{"boy"}</p>
                  <input
                    type="radio"
                    checked={userSex === "girl"}
                    onChange={() => setUserSex("girl")}
                  ></input>
                  <p>{"girl"}</p>
                </div>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-100">
                <p>{"Email"}</p>
                <input
                  className="form-input"
                  onChange={(e) => setUserEmail(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-100">
                <p>{"Password"}</p>
                <input
                  className="form-input"
                  type="password"
                  onChange={(e) => setUserPassword(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-100">
                <p>{"Confirm Password"}</p>
                <input
                  className="form-input"
                  type="password"
                  onChange={(e) => setUserPasswordCheck(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-50 justify-content-center">
                <a
                  className="sbt-btn d-flex flex-column w-80"
                  onClick={() => submitHandler()}
                >
                  <p>{"Create"}</p>
                </a>
              </div>
              <div className="d-flex flex-column">
                <p className="mt-3 mb-1">{"Have an account?"}</p>
                <p className="mt-1 mb-3">
                  {"Click "}
                  <a href="/fa/login" className="mode-text-14">
                    {"here"}
                  </a>
                </p>
              </div>
            </div>
            {signupError && (
              <div className="mode-text-11 font-12">{messageError}</div>
            )}
          </div>
        </div>
      </div>
      <FooterEn />
    </div>
  );
}

export default SignUpEn;
